import React, { useState, useEffect } from "react";
import { Button, Modal, Form, Label, Icon } from "semantic-ui-react";
import PropTypes from "prop-types";

import Joi from "joi";
// Components
import { isEmpty, map, reject, toLower, isEqual, trim, get } from "lodash";

// Modals
import { connect } from "react-redux";
import ConfirmModal from "@Modals/ConfirmModal";
import genericAction from "@Actions/generic";

// redux
import IkTable from "@Components/IkTable";
import dataHandler from "@Utils/dataHandler";
import Input from "@Components/Input";
import Text from "@Components/Text";
// Styles
import styles from "./styles.module.css";

const ContactGroupsCrud = ({ modalCrud, tableValue, contactDataAll, onClose, apiData, contactData, dispatch }) => {
	const schema = Joi.object().keys({
		nameGroup: Joi.string().min(4).messages({
			"string.min": "Nombre debe tener mínimo 4 caracteres",
			"string.empty": "Nombre es un campo requerido",
		}),
		nombreGroupRepet: Joi.string().messages({
			"string.empty": "El Título ya existe",
		}),
		tableValueContact: Joi.array().min(1).messages({
			"array.min": "Contacto es un campo requerido",
		}),
	});
	const [open, setOpen] = useState(false);
	const [filteredItems, setFilteredItems] = useState([]);
	const [filteredCount, setfilteredCount] = useState(null);
	const [checkAllData, setCheckAllData] = useState([]);
	const [tableValueContact, setTableValueContact] = useState([]);
	const [errors, setErrors] = useState({
		nameGroup: "",
		nombreGroupRepet: "",
		tableValueContact: "",
	});
	const [initialFormData, setInitialFormData] = useState([]);
	const [modalOption, setModalOption] = useState("");
	const [nameGroup, setNameGroup] = useState("");

	const defaultParams = { page: 1, orderKey: "contactId", orderDir: "desc" };

	useEffect(() => {
		setModalOption(modalCrud);
		setFilteredItems(contactData.items);
		setfilteredCount(contactData.count);
		if (modalCrud !== "Add") {
			setInitialFormData({
				nameGroup: get(tableValue, "name", ""),
				tableValueContact: get(tableValue, "companyContacts", []),
			});

			setNameGroup(get(tableValue, "name", ""));
			setTableValueContact(get(tableValue, "companyContacts", []));
		} else {
			setInitialFormData({
				nameGroup: "",
				tableValueContact: [],
			});
		}
	}, [tableValue]);

	// handle save
	const handlerSaved = async () => {
		let nombreGroupRepet = "ejemplo";
		let contactDataAllUpd = contactDataAll;
		if (modalOption !== "Add") {
			contactDataAllUpd = reject(contactDataAll, { id: tableValue.id });
		}

		for (const item of contactDataAllUpd) {
			if (toLower(item.name) === toLower(nameGroup)) {
				nombreGroupRepet = "";
			}
		}

		const validation = schema.validate(
			{
				nameGroup,
				nombreGroupRepet,
				tableValueContact,
			},
			{ abortEarly: false }
		);
		if (validation.error) {
			const { details } = validation.error;
			let errorsVal = {
				nameGroup: "",
				nombreGroupRepet: "",
				tableValueContact: "",
			};
			map(details, (item) => {
				errorsVal = { ...errorsVal, [item.context.key]: item.message };
			});
			setErrors(errorsVal);
		} else {
			let nameValue = nameGroup;
			if (isEmpty(nameGroup)) {
				nameValue = null;
			}
			const contactIdList = map(tableValueContact, (item) => {
				return item.contactId;
			});
			let data = { name: trim(nameValue), contactIdList };
			if (modalOption === "Add") {
				const dataAdd = await dispatch(genericAction({ method: "post", route: "contactgroups", body: data }));
				if (!isEmpty(dataAdd)) {
					setNameGroup("");
					apiData("Add");
				}
			} else {
				const idContacts = map(get(tableValue, "companyContacts", []), (item) => {
					return item.id;
				});
				data = { ...data, prevContactIdList: idContacts };

				const dataEdit = await dispatch(genericAction({ method: "patch", route: `contactgroups/${tableValue.id}`, body: data }));

				if (!isEmpty(dataEdit)) {
					apiData("Edit");
				}
			}

			setErrors({
				nameGroup: "",
				nombreGroupRepet: "",
				types: [],
			});
		}
	};

	// modal
	const cancelModal = () => {
		onClose();
	};

	const modalOpen = () => {
		if (isEqual(initialFormData, { nameGroup, tableValueContact })) {
			cancelModal();
		} else if (open) {
			setOpen(false);
		} else {
			setOpen(true);
		}
	};

	const handlerMultiple = (selectedItems) => {
		setTableValueContact(selectedItems);
	};
	const handlerData = async (params, printable, findAll) => {
		const data = await dataHandler({
			dispatch,
			url: "contacts",
			params,
		});
		if (printable) {
			return null;
		}
		if (findAll) {
			setCheckAllData(data.items);
		} else {
			setFilteredItems(data.items);
			setfilteredCount(data.count);
		}
		return null;
	};

	const handlerTable = (name, item) => {
		if (name === "Eraser") {
			setFilteredItems(reject(filteredItems, { id: item.id }));
		}
	};

	return (
		<Modal size="small" open closeIcon onClose={modalOpen} dimmer="blurring">
			<Modal.Header className="modalHeader">
				<div>
					{modalOption === "Watch" && <Icon name="eye" />}
					{modalOption === "Edit" && <Icon name="edit" />}
					{modalOption === "Add" && <Icon name="plus" />}
					{" Grupo Contactos"}
					{modalOption !== "Add" && `- Id: ${String(tableValue.id)}`}
				</div>
				<div>
					{modalOption === "Watch" && (
						<Button
							onClick={() => {
								setModalOption("Edit");
							}}
							className="modalButtonEdit">
							<Icon name="edit" />
						</Button>
					)}

					{modalOption === "Edit" && (
						<Button
							onClick={() => {
								setModalOption("Watch");
							}}
							className="modalButtonWatch">
							<Icon name="eye" />
						</Button>
					)}
				</div>
			</Modal.Header>
			<Modal.Content>
				<div>
					<Form>
						<Text className={styles.textBox}>
							Grupo:
							<span className={styles.required}>*</span>
						</Text>
						<Input
							value={nameGroup}
							icon="unordered list"
							placeholder="nombre"
							name="nameGroup"
							disabled={modalOption === "Watch"}
							fluid
							error={!isEmpty(errors.nameGroup) && { content: errors.nameGroup, pointing: "above" }}
							onChange={(e) => {
								return setNameGroup(e.target.value);
							}}
						/>
						{!isEmpty(errors.nombreGroupRepet) && (
							<Label className={styles.messageError} pointing prompt>
								{errors.nombreGroupRepet}
							</Label>
						)}
					</Form>
					<Text className={styles.textBoxContact}>
						Contactos:
						<span className={styles.required}>*</span>
					</Text>
					<div className={styles.tableGroupList}>
						<IkTable
							data={filteredItems}
							columns={[
								{
									label: "Acción",
									action: [{ content: "trash", color: "#b43333", onClick: "Eraser", type: "icon" }],
									dataPosition: "center",
									width: 1,
								},
								{
									multiple: true,
									key: "contactId",
									dataPosition: "center",
								},
								{
									label: "ID",
									key: "contactId",
									format: "string",
									dataPosition: "center",

									width: 1,
								},
								{
									label: "Nombre",
									key: "name",
									format: "string",
									width: 6,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
									sortKey: null,
								},
								{
									label: "ID Enlace",
									key: "contactSharedId",
									format: "string",
									dataPosition: "center",
									width: 4,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
									sortKey: null,
								},
								{
									label: "Canal",
									key: "contact.channel",
									format: "string",
									dataPosition: "center",
									width: 4,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
									sortKey: null,
								},
							]}
							totalRows={filteredCount}
							handlerMultiple={handlerMultiple}
							checkAllData={checkAllData}
							defaultParams={defaultParams}
							dataHandler={handlerData}
							handlerTable={handlerTable}
						/>
					</div>
					<Label className={styles.messageError} style={isEmpty(errors.tableValueContact) ? { display: "none" } : null} pointing prompt>
						{errors.tableValueContact}
					</Label>
				</div>
			</Modal.Content>
			<Modal.Actions className={styles.modalHeader}>
				{modalOption === "Watch" ? (
					<Button className={styles.negativeButton} onClick={modalOpen}>
						Cerrar
					</Button>
				) : (
					<Button className={styles.negativeButton} onClick={modalOpen}>
						Atrás
					</Button>
				)}

				{modalOption !== "Watch" && (
					<Button className={styles.positiveButton} onClick={handlerSaved}>
						{modalOption === "Add" ? "Guardar" : "Modificar"}
					</Button>
				)}
			</Modal.Actions>
			{open && (
				<ConfirmModal
					visible
					header="Confirmar"
					content="Está seguro que desea salir del formulario"
					onConfirm={cancelModal}
					onDismiss={modalOpen}
				/>
			)}
		</Modal>
	);
};

function mapStateToProps({ company, user }) {
	return {
		companyName: company.name,
		userName: user.name,
	};
}
ContactGroupsCrud.propTypes = {
	tableValue: PropTypes.object,
	onClose: PropTypes.func,
	apiData: PropTypes.func,
	contactData: PropTypes.object,
	dispatch: PropTypes.func,
	modalCrud: PropTypes.string,
	contactDataAll: PropTypes.array,
};
export default connect(mapStateToProps)(ContactGroupsCrud);
